var map = {
	"./Inter-Black.woff": 3629,
	"./Inter-BlackItalic.woff": 9385,
	"./Inter-Bold.woff": 9082,
	"./Inter-BoldItalic.woff": 2907,
	"./Inter-ExtraBold.woff": 6635,
	"./Inter-ExtraBoldItalic.woff": 5561,
	"./Inter-ExtraLight.woff": 1401,
	"./Inter-ExtraLightItalic.woff": 5830,
	"./Inter-Italic.woff": 5043,
	"./Inter-Light.woff": 357,
	"./Inter-LightItalic.woff": 6187,
	"./Inter-Medium.woff": 4225,
	"./Inter-MediumItalic.woff": 9049,
	"./Inter-Regular.woff": 2488,
	"./Inter-SemiBold.woff": 494,
	"./Inter-SemiBoldItalic.woff": 440,
	"./Inter-Thin.woff": 5415,
	"./Inter-ThinItalic.woff": 3662
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7656;